import styled from 'styled-components';

import { MOBILE_PADDING, WHITE, BLACK, PAGE_WIDTH } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.section`
  background-color: ${({ color }) => color};
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;
  padding: ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    flex-direction: ${({ index }) => (index % 2 === 0 ? 'row' : 'row-reverse')};
    justify-content: space-between;
    padding: 100px 80px;
  `};

  ${media.desktop`
    min-height: 700px;
  `};
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 100%;

  ${media.tabletL`
    align-items: flex-start;
  `};
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 25px 0;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    margin: 0;
    text-align: left;
    width: calc(50% - 40px);
  `};
`;

export const Season = styled.h4`
  font-weight: 400;
  text-transform: uppercase;
  font-size: 14px;
  margin: 0;
  max-width: 400px;
  width: 100%;

  ${media.tabletL`
    font-size: 18px;
  `};
`;

export const Title = styled.h1`
  font-size: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  max-width: 400px;
  width: 100%;

  > span {
    font-weight: 600;
  }

  ${media.tabletL`
    font-size: 44px;
    margin: 10px 0 0 0;
  `};
`;

export const Description = styled.p`
  margin: 0;
  margin-bottom: 20px;
  width: 100%;

  ${media.tabletL`
    margin-bottom: 50px;
    margin-top: 25px;
  `};
`;

export const ImageWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;

  ${media.tabletL`
    width: calc(50% - 40px);
  `};
`;

export const Button = styled.div`
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  display: flex;
  font-size: 14px;
  font-weight: 800;
  height: 53px;
  justify-content: center;
  line-height: 53px;
  letter-spacing: 2px;
  width: 220px;
  text-align: center;
  text-transform: uppercase;

  ${media.tabletL`
    height: 72px;
    line-height: 72px;
    width: 300px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/InspirationPage/InspirationSection/InspirationSection.style.js